export default {
      id: "oc-cloudpods-usage",
      viewBox: "0 0 1400 1400",
      url: __webpack_public_path__ + "sprite.svg#oc-cloudpods",
      toString: function () {
        return this.url;
      }
    }